module.exports = __webpack_public_path__ + "img/base_patrimoine_ferroviaire.7fea16dd.svg";